function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var saito = require('./../../lib/saito/saito');
var Transaction = require('../../lib/saito/transaction')["default"];
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var ModTemplate = require('./../../lib/templates/modtemplate');
var VaultMain = require('./lib/ui/main');
var VaultHome = require('./index');
var AccessFileOverlay = require('./lib/ui/overlays/load-nfts.js');
var WitnessOverlay = require('./lib/ui/overlays/witness');
var _require = require('./lib/contracts'),
  buildDefaultAccessScript = _require.buildDefaultAccessScript;
var loan = require('./lib/contracts/loan');
var _require2 = require('./lib/transactions/add-file'),
  receiveVaultAddFileTransaction = _require2.receiveVaultAddFileTransaction;
var rentalCheckout = require('./lib/transactions/rental-checkout');
function findCheckPathHop(node) {
  if (!node || _typeof(node) !== 'object') {
    return null;
  }
  if (String(node.op || '').toUpperCase() === 'CHECKPATHHOP') {
    return node;
  }
  if (Array.isArray(node.args)) {
    for (var i = 0; i < node.args.length; i++) {
      var found = findCheckPathHop(node.args[i]);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

/**
 * Same hop selector as FILE_SCRIPT CHECKPATHHOP / checkout:
 * FIRST hop where value.delegated == 0.
 */
function _firstUndelegatedHopFromRental(file_access_script, path) {
  var _cph$witness;
  var script_obj = file_access_script;
  if (typeof script_obj === 'string') {
    try {
      script_obj = JSON.parse(script_obj);
    } catch (err) {
      script_obj = null;
    }
  }
  var cph = findCheckPathHop(script_obj);
  var creator_pk = (cph === null || cph === void 0 ? void 0 : cph.publickey) || null;
  var hops = Array.isArray(cph === null || cph === void 0 || (_cph$witness = cph.witness) === null || _cph$witness === void 0 ? void 0 : _cph$witness.hops) ? cph.witness.hops : Array.isArray(path) ? path : [];
  for (var i = 0; i < hops.length; i++) {
    var hop = hops[i] || {};
    var value_obj = null;
    try {
      value_obj = JSON.parse(Buffer.from(String(hop.value || ''), 'base64').toString('utf8'));
    } catch (err) {
      value_obj = null;
    }
    if (value_obj && value_obj.delegated === 0) {
      return {
        creator_pk: creator_pk,
        renter: hop.to || null,
        expires_at: value_obj.expires_at
      };
    }
  }
  return {
    creator_pk: creator_pk,
    renter: null,
    expires_at: null
  };
}
function formatVaultScriptForLog(script) {
  if (script == null || script === '') {
    return '(empty)';
  }
  if (typeof script !== 'string') {
    try {
      return JSON.stringify(script, null, 2);
    } catch (err) {
      return String(script);
    }
  }
  try {
    return JSON.stringify(JSON.parse(script), null, 2);
  } catch (err) {
    return script;
  }
}
var Vault = /*#__PURE__*/function (_ModTemplate) {
  function Vault(app) {
    var _this;
    _classCallCheck(this, Vault);
    _this = _callSuper(this, Vault, [app]);
    _this.appname = 'Vault';
    _this.name = 'Vault';
    _this.slug = 'vault';
    _this.dependencies = ['Archive'];
    _this.description = 'Storage Vault regulated by NFT Keys';
    _this.categories = 'Utility Cryptography Programming';
    _this.status = 'prod';
    _this["class"] = 'app';
    _this.icon = 'fas fa-vault';
    _this.peer_connected = false;
    _this.peer = null;
    Object.assign(_this, rentalCheckout);

    //
    // vars for users / uploads
    //
    _this.file = null;
    _this.filename = '';
    _this.file_id = null;
    _this.mode = 'private';
    _this.styles = ['/vault/style.css'];
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: 'Vault - Secure Storage',
      url: '/vault',
      description: 'NFT-based cloud storage',
      image: '/vault/img/splash.png'
    });
    _this.access_file_overlay = new AccessFileOverlay(_this.app, _this);
    return _this;
  }
  _inherits(Vault, _ModTemplate);
  return _createClass(Vault, [{
    key: "firstUndelegatedHopFromRental",
    value: function firstUndelegatedHopFromRental(file_access_script, path) {
      return _firstUndelegatedHopFromRental(file_access_script, path);
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var SaitoTransactionMonitor;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.app.BROWSER) {
                SaitoTransactionMonitor = require('../../lib/saito/ui/saito-transaction-monitor/saito-transaction-monitor');
                this.transaction_monitor = new SaitoTransactionMonitor(this.app, this);
              }
              if (!this.browser_active) {
                _context.n = 2;
                break;
              }
              this.main = new VaultMain(app, this, '.saito-container');
              this.addComponent(this.main);
              this.header = new SaitoHeader(app, this);
              _context.n = 1;
              return this.header.initialize(app);
            case 1:
              this.addComponent(this.header);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Vault, "render", this, 3)([]);
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }() /////////////////////////////////
    // inter-module communications //
    /////////////////////////////////
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      var this_mod = this;

      //
      // Optional N-WASM library action: store the canonical N-WASM game
      // transaction/message (not a raw-ROM-only payload) behind a Vault key.
      //
      if (type === 'nwasm-library-actions') {
        return {
          id: 'vault-upload',
          title: 'Upload to Vault',
          description: 'Save remotely, use NFT for access control.',
          image: '/nwasm/img/upload_to_vault.png',
          rank: 20,
          callback: function () {
            var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, mod) {
              var ctx,
                game_data,
                wallet_balance,
                name,
                filename,
                envelope,
                json,
                b64,
                safe,
                data_uri,
                _args3 = arguments;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    ctx = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                    game_data = ctx.game_data;
                    if (!(!(game_data !== null && game_data !== void 0 && game_data.module) || !(game_data !== null && game_data !== void 0 && game_data.file))) {
                      _context3.n = 1;
                      break;
                    }
                    throw new Error('Vault upload requires N-WASM game data');
                  case 1:
                    _context3.n = 2;
                    return this_mod.app.wallet.getBalance('SAITO');
                  case 2:
                    wallet_balance = _context3.v;
                    if (!(wallet_balance === 0n)) {
                      _context3.n = 3;
                      break;
                    }
                    siteMessage('Insufficient SAITO to Create Vault NFTs...', 3000);
                    this_mod.app.connection.emit('saito-purchase-launch');
                    throw new Error('Insufficient SAITO for Vault upload');
                  case 3:
                    this_mod.attachStyleSheets();
                    name = (game_data.name || ctx.file_name || 'game').trim() || 'game'; //
                    // N-WASM library discovery classifies Vault games by ROM-like filename
                    // (.z64 / .n64 / .v64). Normalize so titles without an extension still
                    // appear after upload.
                    //
                    filename = (ctx.file_name || "".concat(name, ".z64")).trim();
                    if (!/\.(z64|n64|v64)$/i.test(filename)) {
                      filename = "".concat(filename.replace(/\.[^.]+$/, '') || name, ".z64");
                    }

                    //
                    // Canonical N-WASM game payload (same structure as NFT / local archive),
                    // wrapped so Vault stores the full txmsg-compatible object — not raw ROM only.
                    //
                    envelope = {
                      module: 'Nwasm',
                      title: name,
                      name: name,
                      data: game_data
                    };
                    json = JSON.stringify(envelope);
                    b64 = Buffer.from(json).toString('base64');
                    safe = encodeURIComponent(filename);
                    data_uri = "data:application/json;name=".concat(safe, ";base64,").concat(b64);
                    this_mod.file = data_uri;
                    this_mod.filename = filename;

                    //
                    // Wait until CREATE KEY → upload → mint confirmation finishes so the
                    // library can refresh with the new Vault game before closing.
                    // Return the confirmed metadata so N-WASM.addGameFromVaultResult()
                    // receives nft_id / file_id / nft_tx (do not discard the Promise value).
                    //
                    _context3.n = 4;
                    return new Promise(function (resolve, reject) {
                      this_mod.access_file_overlay.file_upload_overlay.render({
                        file: data_uri,
                        filename: filename,
                        prefilled: true,
                        library_mode: true,
                        onComplete: function onComplete(result) {
                          return resolve(result);
                        },
                        onError: function onError(err) {
                          return reject(err instanceof Error ? err : new Error(String(err || 'Vault upload failed')));
                        }
                      });
                    });
                  case 4:
                    return _context3.a(2, _context3.v);
                }
              }, _callee3);
            }));
            function callback(_x2, _x3) {
              return _callback.apply(this, arguments);
            }
            return callback;
          }()
        };
      }
      if (type === 'saito-header') {
        var x = [];
        if (!this.browser_active) {
          this_mod.attachStyleSheets();
          x.push({
            text: 'Vault',
            icon: this.icon,
            rank: 105,
            type: 'quicklaunch',
            callback: function callback(app, id) {
              //navigateWindow('/vault');
              this_mod.access_file_overlay.render();
            },
            navigation: '/vault'
          });
        }
        return x;
      }
      if (type === 'saito-create-nft') {
        return {
          title: 'NFT Access Key',
          "class": ['vault-nft-key', 'vault-nft-rental'],
          json: {
            txsig: 'YYYYY',
            archive: 'ZZZZZ'
          }
        };
      }
      if (type === 'saito-nft-media') {
        var vault_app = this.app;
        return {
          // Canonical access-key type; "vault" kept for legacy keys already on-chain.
          "class": ['vault-nft-key', 'vault-nft-rental', 'vault'],
          returnMediaDisplay: function returnMediaDisplay(nft) {
            if (!(nft !== null && nft !== void 0 && nft.json)) {
              return null;
            }
            try {
              var _obj = JSON.parse(nft.json);
              var backgroundImage = _obj.file_access_script ? '/vault/img/crystal_key_min.png' : '/vault/img/jade_key_min.png';
              var jsonText = vault_app.browser.escapeHTML(String(nft.json));
              return {
                backgroundImage: backgroundImage,
                innerHtml: "<div class=\"saito-nft-card-text\">".concat(jsonText, "</div>")
              };
            } catch (err) {
              return null;
            }
          }
        };
      }
      if (type === 'saito-nft-download') {
        var nft = obj;
        if (!nft || typeof nft.returnType !== 'function') {
          return null;
        }
        var nft_type = nft.returnType();
        if (nft_type !== 'vault-nft-key' && nft_type !== 'vault-nft-rental' && nft_type !== 'vault') {
          return null;
        }
        return {
          download: function () {
            var _download = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, download_nft) {
              var _download_nft$tx, _download_nft$tx$retu, _data, _data2, _data3, _download_nft$slip, _download_nft$slip2, _download_nft$slip3;
              var ensureTx, data, vault_data, witness;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    ensureTx = function ensureTx() {
                      return new Promise(function (resolve) {
                        if (download_nft.tx) {
                          resolve();
                          return;
                        }
                        if (typeof download_nft.fetchTransaction === 'function') {
                          download_nft.fetchTransaction(function () {
                            return resolve();
                          });
                          return;
                        }
                        resolve();
                      });
                    };
                    _context4.n = 1;
                    return ensureTx();
                  case 1:
                    data = (_download_nft$tx = download_nft.tx) === null || _download_nft$tx === void 0 || (_download_nft$tx$retu = _download_nft$tx.returnMessage) === null || _download_nft$tx$retu === void 0 || (_download_nft$tx$retu = _download_nft$tx$retu.call(_download_nft$tx)) === null || _download_nft$tx$retu === void 0 ? void 0 : _download_nft$tx$retu.data;
                    if (!data && download_nft.json) {
                      try {
                        data = JSON.parse(download_nft.json);
                      } catch (err) {
                        data = null;
                      }
                    }
                    vault_data = {
                      nft_id: download_nft.id,
                      file_id: (_data = data) === null || _data === void 0 ? void 0 : _data.file_id,
                      file_access_script: ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.file_access_script) || null,
                      file_name: (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.filename,
                      slip1_utxokey: ((_download_nft$slip = download_nft.slip1) === null || _download_nft$slip === void 0 ? void 0 : _download_nft$slip.utxo_key) || '',
                      slip2_utxokey: ((_download_nft$slip2 = download_nft.slip2) === null || _download_nft$slip2 === void 0 ? void 0 : _download_nft$slip2.utxo_key) || '',
                      slip3_utxokey: ((_download_nft$slip3 = download_nft.slip3) === null || _download_nft$slip3 === void 0 ? void 0 : _download_nft$slip3.utxo_key) || ''
                    };
                    if (vault_data.file_id) {
                      _context4.n = 2;
                      break;
                    }
                    siteMessage('Vault file not found for this NFT', 2000);
                    return _context4.a(2);
                  case 2:
                    if (!vault_data.file_access_script) {
                      _context4.n = 3;
                      break;
                    }
                    if (!this_mod.nft_download_witness) {
                      this_mod.nft_download_witness = new WitnessOverlay(this_mod.app, this_mod);
                    }
                    witness = this_mod.nft_download_witness;
                    witness.access_script = vault_data.file_access_script;
                    witness.vault_entry = vault_data;
                    witness.callback = function (result) {
                      this_mod.sendAccessFileRequest(vault_data, result.access_script);
                    };
                    witness.render();
                    return _context4.a(2);
                  case 3:
                    _context4.n = 4;
                    return this_mod.sendAccessFileRequest(vault_data);
                  case 4:
                    return _context4.a(2);
                }
              }, _callee4);
            }));
            function download(_x4, _x5) {
              return _download.apply(this, arguments);
            }
            return download;
          }()
        };
      }
      return null;
    }
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER || this.offerService) {
        services.push(this.app.network.createPeerService(null, 'vault', 'Secure File Vault'));
      }
      return services;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, peer) {
        var service,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              service = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              if (this.browser_active) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (service.service === 'vault') {
                this.peer = peer;
                this.peer_connected = true;
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onPeerServiceUp(_x6, _x7) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _app$core,
          _app$core2,
          _tx$from3,
          _tx$from4,
          access_script,
          access_hash,
          ok,
          computed_hash,
          hash_match,
          _tx$from,
          _tx$from2,
          _txmsg$data$data,
          archive_mod,
          data,
          _app$core3,
          _app$core4,
          _tx$from7,
          _tx$from8,
          _access_script,
          _access_hash,
          _computed_hash,
          _ok,
          _tx$from5,
          _tx$from6,
          _txmsg$data$data2,
          _archive_mod,
          _data4,
          _args8 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              tx = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
              peer = _args8.length > 2 ? _args8[2] : undefined;
              mycallback = _args8.length > 3 ? _args8[3] : undefined;
              if (!(tx == null)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (!(!txmsg.request || !mycallback)) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, 0);
            case 2:
              if (!(txmsg.request === 'vault access file')) {
                _context8.n = 10;
                break;
              }
              _context8.p = 3;
              if (!(!((_app$core = app.core) !== null && _app$core !== void 0 && (_app$core = _app$core.scripting) !== null && _app$core !== void 0 && _app$core.hash) || !((_app$core2 = app.core) !== null && _app$core2 !== void 0 && (_app$core2 = _app$core2.scripting) !== null && _app$core2 !== void 0 && _app$core2.evaluate))) {
                _context8.n = 4;
                break;
              }
              console.log('ERROR vault access file 1');
              mycallback({
                status: 'err',
                err: 'scripting_unavailable'
              });
              return _context8.a(2, 0);
            case 4:
              console.log('NORMAL vault access file 1');
              access_script = txmsg.data.access_script || '';
              access_hash = txmsg.data.access_hash || '';
              ok = false;
              computed_hash = app.core.scripting.hash(access_script);
              hash_match = computed_hash === access_hash;
              console.log('--------------------------------\nVAULT ACCESS REQUEST RECEIVED\n\naccess_hash:\n' + access_hash + '\n\ncomputed_hash:\n' + computed_hash + '\n\nhash_match:\n' + hash_match + '\n\n--------------------------------');
              console.log('NORMAL vault access file 1');
              if (!(app.core.scripting.hash(access_script) === access_hash)) {
                _context8.n = 6;
                break;
              }
              console.log('--------------------------------\nCALLING RUST SCRIPT VALIDATOR\n--------------------------------');
              _context8.n = 5;
              return app.core.scripting.evaluateWithTransaction(access_script, tx);
            case 5:
              ok = _context8.v;
              console.log('--------------------------------\nSCRIPT VALIDATION RESULT:\n\n' + (ok ? 'true' : 'false') + '\n\n--------------------------------');
            case 6:
              console.log('NORMAL vault access file 2');
              if (ok) {
                _context8.n = 7;
                break;
              }
              console.log('SCRIPT VALIDATION FAILED');
              console.log('--------------------------------\nVAULT ACCESS REQUEST\n--------------------------------\nrequest:\nvault access file\npeer:\n' + (((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || ((_tx$from2 = tx.from) === null || _tx$from2 === void 0 || (_tx$from2 = _tx$from2[0]) === null || _tx$from2 === void 0 ? void 0 : _tx$from2.public_key) || '(none)') + '\nfile_id:\n' + (((_txmsg$data$data = txmsg.data.data) === null || _txmsg$data$data === void 0 ? void 0 : _txmsg$data$data.file_id) || '(none)') + '\naccess_hash submitted:\n' + access_hash + '\nFILE access_script:\n' + formatVaultScriptForLog(access_script) + '\ncomputed FILE access_hash:\n' + computed_hash + '\nhash match:\n' + hash_match + '\nscript validation:\n' + ok + '\nquery owner:\n(not queried — script validation failed)\nquery sig:\n(not queried — script validation failed)\n--------------------------------');
              siteMessage('Supplied Witness Data Incorrect: Access Denied', 2000);
              mycallback({
                status: 'err',
                err: 'access_denied_script_failed'
              });
              return _context8.a(2, 0);
            case 7:
              console.log('NORMAL vault access file 3');

              //
              // If script passes, proceed to Archive
              //
              archive_mod = app.modules.returnModule('Archive');
              archive_mod.access_hash = 1; // ownership restricted
              data = {};
              data.owner = txmsg.data.access_hash;
              data.access_hash = txmsg.data.access_hash;
              data.access_script = txmsg.data.access_script;
              data.sig = txmsg.data.data.file_id;
              data.request_tx = tx;
              console.log('NORMAL vault access file 4');
              console.log('--------------------------------\nVAULT ACCESS REQUEST\n--------------------------------\nrequest:\nvault access file\npeer:\n' + (((_tx$from3 = tx.from) === null || _tx$from3 === void 0 || (_tx$from3 = _tx$from3[0]) === null || _tx$from3 === void 0 ? void 0 : _tx$from3.publicKey) || ((_tx$from4 = tx.from) === null || _tx$from4 === void 0 || (_tx$from4 = _tx$from4[0]) === null || _tx$from4 === void 0 ? void 0 : _tx$from4.public_key) || '(none)') + '\nfile_id:\n' + (data.sig || '(none)') + '\nUSER SUBMITTED access_hash:\n' + access_hash + '\nUSER SUBMITTED FILE access_script:\n' + formatVaultScriptForLog(access_script) + '\ncomputed FILE access_hash:\n' + computed_hash + '\nhash match:\n' + hash_match + '\nscript validation:\n' + ok + '\nVAULT QUERIES owner:\n' + data.owner + '\nVAULT QUERIES sig:\n' + data.sig + '\n--------------------------------');
              this.app.storage.loadTransactions(data, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(txs) {
                  return _regenerator().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        mycallback({
                          status: 'success',
                          err: '',
                          txs: txs
                        });
                      case 1:
                        return _context6.a(2);
                    }
                  }, _callee6);
                }));
                return function (_x9) {
                  return _ref.apply(this, arguments);
                };
              }(), 'localhost', 0);
              _context8.n = 9;
              break;
            case 8:
              _context8.p = 8;
              _t = _context8.v;
              console.log('ERROR processing vault access file...');
              mycallback({
                status: 'err',
                err: JSON.stringify(_t)
              });
            case 9:
              return _context8.a(2, 1);
            case 10:
              if (!(txmsg.request === 'vault access rental')) {
                _context8.n = 18;
                break;
              }
              _context8.p = 11;
              if (!(!((_app$core3 = app.core) !== null && _app$core3 !== void 0 && (_app$core3 = _app$core3.scripting) !== null && _app$core3 !== void 0 && _app$core3.hash) || !((_app$core4 = app.core) !== null && _app$core4 !== void 0 && (_app$core4 = _app$core4.scripting) !== null && _app$core4 !== void 0 && _app$core4.evaluateWithTransaction))) {
                _context8.n = 12;
                break;
              }
              mycallback({
                status: 'err',
                err: 'scripting_unavailable'
              });
              return _context8.a(2, 0);
            case 12:
              _access_script = txmsg.data.access_script || '';
              _access_hash = txmsg.data.access_hash || '';
              _computed_hash = app.core.scripting.hash(_access_script);
              console.log('--------------------------------\nVAULT RENTAL ACCESS REQUEST\n\naccess_hash:\n' + _access_hash + '\n\ncomputed_hash:\n' + _computed_hash + '\n\nLOAN_SCRIPT:\n' + (typeof _access_script === 'string' ? _access_script : JSON.stringify(_access_script, null, 2)) + '\n\n--------------------------------');
              _ok = false;
              if (!(_computed_hash === _access_hash)) {
                _context8.n = 14;
                break;
              }
              _context8.n = 13;
              return app.core.scripting.evaluateWithTransaction(_access_script, tx);
            case 13:
              _ok = _context8.v;
            case 14:
              console.log('[VAULT RENTAL ACCESS] LOAN_SCRIPT eval:', _ok ? 'true' : 'false');
              if (_ok) {
                _context8.n = 15;
                break;
              }
              console.log('--------------------------------\nVAULT ACCESS REQUEST\n--------------------------------\nrequest:\nvault access rental\npeer:\n' + (((_tx$from5 = tx.from) === null || _tx$from5 === void 0 || (_tx$from5 = _tx$from5[0]) === null || _tx$from5 === void 0 ? void 0 : _tx$from5.publicKey) || ((_tx$from6 = tx.from) === null || _tx$from6 === void 0 || (_tx$from6 = _tx$from6[0]) === null || _tx$from6 === void 0 ? void 0 : _tx$from6.public_key) || '(none)') + '\nfile_id:\n' + (((_txmsg$data$data2 = txmsg.data.data) === null || _txmsg$data$data2 === void 0 ? void 0 : _txmsg$data$data2.file_id) || '(none)') + '\nUSER SUBMITTED access_hash:\n' + _access_hash + '\nUSER SUBMITTED RENTAL/LOAN access_script:\n' + formatVaultScriptForLog(_access_script) + '\ncomputed RENTAL/LOAN access_hash:\n' + _computed_hash + '\nhash match:\n' + (_computed_hash === _access_hash) + '\nscript validation:\n' + _ok + '\nquery owner:\n(not queried — script validation failed)\nquery sig:\n(not queried — script validation failed)\n--------------------------------');
              mycallback({
                status: 'err',
                err: 'access_denied_script_failed'
              });
              return _context8.a(2, 0);
            case 15:
              _archive_mod = app.modules.returnModule('Archive');
              _archive_mod.access_hash = 1;
              _data4 = {};
              _data4.owner = _access_hash;
              _data4.access_hash = _access_hash;
              _data4.access_script = _access_script;
              _data4.sig = txmsg.data.data.file_id;
              _data4.request_tx = tx;
              console.log('--------------------------------\nVAULT ACCESS REQUEST\n--------------------------------\nrequest:\nvault access rental\npeer:\n' + (((_tx$from7 = tx.from) === null || _tx$from7 === void 0 || (_tx$from7 = _tx$from7[0]) === null || _tx$from7 === void 0 ? void 0 : _tx$from7.publicKey) || ((_tx$from8 = tx.from) === null || _tx$from8 === void 0 || (_tx$from8 = _tx$from8[0]) === null || _tx$from8 === void 0 ? void 0 : _tx$from8.public_key) || '(none)') + '\nfile_id:\n' + (_data4.sig || '(none)') + '\nUSER SUBMITTED access_hash:\n' + _access_hash + '\nUSER SUBMITTED RENTAL/LOAN access_script:\n' + formatVaultScriptForLog(_access_script) + '\ncomputed RENTAL/LOAN access_hash:\n' + _computed_hash + '\nhash match:\n' + (_computed_hash === _access_hash) + '\nscript validation:\n' + _ok + '\nVAULT QUERIES owner:\n' + _data4.owner + '\nVAULT QUERIES sig:\n' + _data4.sig + '\n--------------------------------');
              this.app.storage.loadTransactions(_data4, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(txs) {
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.n) {
                      case 0:
                        mycallback({
                          status: 'success',
                          err: '',
                          txs: txs
                        });
                      case 1:
                        return _context7.a(2);
                    }
                  }, _callee7);
                }));
                return function (_x0) {
                  return _ref2.apply(this, arguments);
                };
              }(), 'localhost', 0);
              _context8.n = 17;
              break;
            case 16:
              _context8.p = 16;
              _t2 = _context8.v;
              console.log('[VAULT RENTAL ACCESS] ERROR', _t2);
              mycallback({
                status: 'err',
                err: JSON.stringify(_t2)
              });
            case 17:
              return _context8.a(2, 1);
            case 18:
              if (!(txmsg.request === 'vault add file')) {
                _context8.n = 20;
                break;
              }
              _context8.n = 19;
              return receiveVaultAddFileTransaction(app, this, tx, mycallback);
            case 19:
              return _context8.a(2, _context8.v);
            case 20:
              if (!(txmsg.request === 'vault checkout rental')) {
                _context8.n = 22;
                break;
              }
              _context8.n = 21;
              return this.receiveCheckOutRentalTransaction(tx, mycallback);
            case 21:
              return _context8.a(2, _context8.v);
            case 22:
              return _context8.a(2);
          }
        }, _callee8, this, [[11, 16], [3, 8]]);
      }));
      function handlePeerTransaction(_x8) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "sendAccessFileRequest",
    value: function () {
      var _sendAccessFileRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this$app$core,
          _this2 = this;
        var vault_data,
          access_script_override,
          mycallback,
          nftid,
          utxokey1,
          utxokey2,
          utxokey3,
          file_id,
          access_script,
          access_hash,
          access_script_obj,
          data,
          computed_hash,
          script_pretty,
          _args9 = arguments,
          _t3;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              vault_data = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : null;
              access_script_override = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
              mycallback = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : null;
              if ((_this$app$core = this.app.core) !== null && _this$app$core !== void 0 && (_this$app$core = _this$app$core.scripting) !== null && _this$app$core !== void 0 && _this$app$core.hash) {
                _context9.n = 1;
                break;
              }
              console.warn('VAULT: app.core.scripting not available, aborting');
              return _context9.a(2, null);
            case 1:
              //
              // Standard path builds CHECKOWNNFT from nft utxokeys.
              // Custom keys pass a complete access_script via access_script_override.
              //
              nftid = null;
              utxokey1 = null;
              utxokey2 = null;
              utxokey3 = null;
              file_id = null; //
              // if called from UI (LoadNFTs click) use provided values
              //
              if (vault_data) {
                nftid = vault_data.nft_id;
                utxokey1 = vault_data.slip1_utxokey;
                utxokey2 = vault_data.slip2_utxokey;
                utxokey3 = vault_data.slip3_utxokey;
                file_id = vault_data.file_id;
              } else {
                nftid = prompt('NFT ID (nftid):');
                utxokey1 = prompt('NFT utxokey1:');
                utxokey2 = prompt('NFT utxokey2:');
                utxokey3 = prompt('NFT utxokey3:');
                file_id = this.file_id;
              }
              if (!(!nftid || !utxokey1 || !utxokey2 || !utxokey3)) {
                _context9.n = 2;
                break;
              }
              console.warn('VAULT: Missing nftid or one of the utxokeys, aborting');
              return _context9.a(2, null);
            case 2:
              access_script = '';
              access_hash = '';
              if (!access_script_override) {
                _context9.n = 6;
                break;
              }
              _context9.p = 3;
              access_script = typeof access_script_override === 'string' ? access_script_override : JSON.stringify(access_script_override);
              JSON.parse(access_script);
              access_hash = this.app.core.scripting.hash(access_script);
              _context9.n = 5;
              break;
            case 4:
              _context9.p = 4;
              _t3 = _context9.v;
              alert('Error submitting access script: invalid JSON?');
              return _context9.a(2);
            case 5:
              _context9.n = 7;
              break;
            case 6:
              //
              // Standard CHECKOWNNFT flow
              //
              access_script_obj = buildDefaultAccessScript({
                nftid: nftid,
                utxokey1: utxokey1,
                utxokey2: utxokey2,
                utxokey3: utxokey3
              });
              access_script = JSON.stringify(access_script_obj);
              access_hash = this.app.core.scripting.hash(access_script);
            case 7:
              //
              // if file_id still not set, fall back to this.file_id
              //
              if (!file_id) {
                console.log('VAULT: file_id not set from vault_data, using this.file_id');
                file_id = this.file_id;
              }
              data = {
                request: 'vault access file',
                access_script: access_script,
                access_hash: access_hash,
                data: {
                  file_id: file_id
                }
              };
              if (this.peer) {
                computed_hash = this.app.core.scripting.hash(access_script);
                script_pretty = JSON.stringify(JSON.parse(access_script), null, 2);
                console.log('--------------------------------\nVAULT ACCESS REQUEST (CLIENT SEND)\n--------------------------------\nrequest:\nvault access file\naccess_script_override supplied:\n' + !!access_script_override + '\nfile_id:\n' + (file_id || '(none)') + '\nUSER SUBMITTED access_hash:\n' + access_hash + '\nUSER SUBMITTED FILE access_script:\n' + script_pretty + '\ncomputed FILE access_hash:\n' + computed_hash + '\nhash match:\n' + (computed_hash === access_hash) + '\nVAULT WILL QUERY owner:\n' + access_hash + '\nVAULT WILL QUERY sig:\n' + file_id + '\n--------------------------------');
                this.app.network.sendRequestAsTransaction('vault access file', data, function (res) {
                  console.log('$$$');
                  console.log('$$$');
                  console.log('RECEIVED RESPONSE: ');
                  console.log('$$$');
                  console.log('$$$');

                  // Handle undefined or error responses
                  if (!res) {
                    console.error('VAULT: No response received (network error or timeout)');
                    if (mycallback) {
                      mycallback(null); // Pass null to NWASM callback
                    }
                    return;
                  }

                  // Check for error status
                  if (res.status === 'err') {
                    console.error('VAULT: Error from vault:', res);
                    if (mycallback) {
                      mycallback(null); // Pass null to NWASM callback
                    }
                    return;
                  }

                  // Handle case where res might be a Transaction object instead of {status, txs}
                  var txs = [];
                  if (res.txs) {
                    txs = res.txs;
                  } else if (Array.isArray(res)) {
                    txs = res;
                  } else if (res.status === 'success' && res.txs) {
                    txs = res.txs;
                  }
                  if (txs.length > 0) {
                    for (var i = 0; i < txs.length; i++) {
                      var tx = new Transaction();
                      tx.deserialize_from_web(_this2.app, txs[i]);
                      txmsg = tx.returnMessage();
                      try {
                        var filename = txmsg.data.name;
                        if (!filename) {
                          filename = prompt('Enter filename to save:') || 'vault.bin';
                        }
                        var parts = txmsg.data.file.split(',');
                        var header = parts[0];
                        var base64Data = parts[1];
                        var mime = header.match(/data:(.*);base64/)[1];
                        if (mycallback) {
                          mycallback(base64Data);
                        } else {
                          var binary = atob(base64Data);
                          var len = binary.length;
                          var bytes = new Uint8Array(len);
                          for (var _i = 0; _i < len; _i++) {
                            bytes[_i] = binary.charCodeAt(_i);
                          }
                          var blob = new Blob([bytes], {
                            type: mime
                          });
                          var url = URL.createObjectURL(blob);
                          var a = document.createElement('a');
                          a.href = url;
                          a.download = filename || 'download';
                          a.click();
                          URL.revokeObjectURL(url);
                        }
                      } catch (err) {
                        console.log('VAULT: ERROR while handling downloaded file: ' + JSON.stringify(err));
                      }
                    }
                  }
                }, this.peer.publicKey, true);
                siteMessage('Transferring File...', 3000);
              } else {
                console.warn('VAULT: no peer found, cannot send vault access request');
              }
            case 8:
              return _context9.a(2);
          }
        }, _callee9, this, [[3, 4]]);
      }));
      function sendAccessFileRequest() {
        return _sendAccessFileRequest.apply(this, arguments);
      }
      return sendAccessFileRequest;
    }()
    /**
     * Request the Vault file for a Store rental NFT using the instantiated LOAN_SCRIPT.
     * Does not use FILE_SCRIPT or CHECKOWNNFT. Ordinary keys keep sendAccessFileRequest().
     *
     * @param {object} rental_nft SaitoNFT or { tx / data } with file_id, path, file_access_script
     * @param {function} [mycallback] receives base64 file bytes or null
     */
  }, {
    key: "sendAccessRentalFileRequest",
    value: function () {
      var _sendAccessRentalFileRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _this$app$core2,
          _rental_nft$tx,
          _rental_nft$tx$return,
          _this3 = this;
        var rental_nft,
          mycallback,
          data,
          file_id,
          path,
          file_access_script,
          hop,
          creator_pk,
          renter,
          expires_at,
          loan_script,
          access_script,
          access_hash,
          payload,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              rental_nft = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : null;
              mycallback = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
              if ((_this$app$core2 = this.app.core) !== null && _this$app$core2 !== void 0 && (_this$app$core2 = _this$app$core2.scripting) !== null && _this$app$core2 !== void 0 && _this$app$core2.hash) {
                _context0.n = 1;
                break;
              }
              console.warn('VAULT: app.core.scripting not available, aborting rental access');
              if (mycallback) {
                mycallback(null);
              }
              return _context0.a(2, null);
            case 1:
              if (rental_nft) {
                _context0.n = 2;
                break;
              }
              console.warn('VAULT: sendAccessRentalFileRequest missing rental NFT');
              if (mycallback) {
                mycallback(null);
              }
              return _context0.a(2, null);
            case 2:
              data = (typeof ((_rental_nft$tx = rental_nft.tx) === null || _rental_nft$tx === void 0 ? void 0 : _rental_nft$tx.returnMessage) === 'function' ? (_rental_nft$tx$return = rental_nft.tx.returnMessage()) === null || _rental_nft$tx$return === void 0 ? void 0 : _rental_nft$tx$return.data : null) || rental_nft.data || {};
              file_id = String(data.file_id || rental_nft.file_id || '').trim();
              path = Array.isArray(data.path) ? data.path : [];
              file_access_script = data.file_access_script || rental_nft.file_access_script || null;
              hop = _firstUndelegatedHopFromRental(file_access_script, path);
              creator_pk = hop.creator_pk;
              renter = hop.renter;
              expires_at = hop.expires_at;
              if (!(!file_id || !creator_pk || !renter || expires_at == null)) {
                _context0.n = 3;
                break;
              }
              console.warn('VAULT: rental access missing file_id / creator / renter / expires_at', {
                file_id: file_id,
                creator_pk: creator_pk,
                renter: renter,
                expires_at: expires_at
              });
              if (mycallback) {
                mycallback(null);
              }
              return _context0.a(2, null);
            case 3:
              if (!(Date.now() >= Number(expires_at))) {
                _context0.n = 4;
                break;
              }
              console.log('[VAULT RENTAL ACCESS] client expiry check: rental expired, not sending');
              if (mycallback) {
                mycallback(null);
              }
              return _context0.a(2, null);
            case 4:
              loan_script = loan.instantiate({
                creator_publickey: creator_pk,
                renter_publickey: renter,
                expires_at: expires_at
              });
              access_script = JSON.stringify(loan_script);
              access_hash = this.app.core.scripting.hash(access_script);
              console.log('[VAULT LOAN SCRIPT]\n' + JSON.stringify(loan_script, null, 2));
              console.log('[VAULT LOAN SCRIPT HASH]\n' + access_hash);
              console.log('[VAULT RENTAL ACCESS] submitting hash(instantiated LOAN_SCRIPT) as access_hash');
              console.log('--------------------------------\nVAULT ACCESS REQUEST (CLIENT SEND)\n--------------------------------\nrequest:\nvault access rental\nfile_id:\n' + file_id + '\nUSER SUBMITTED access_hash:\n' + access_hash + '\nUSER SUBMITTED RENTAL/LOAN access_script:\n' + JSON.stringify(loan_script, null, 2) + '\ncomputed RENTAL/LOAN access_hash:\n' + access_hash + '\nVAULT WILL QUERY owner:\n' + access_hash + '\nVAULT WILL QUERY sig:\n' + file_id + '\n--------------------------------');
              payload = {
                request: 'vault access rental',
                access_script: access_script,
                access_hash: access_hash,
                data: {
                  file_id: file_id
                }
              };
              if (this.peer) {
                _context0.n = 5;
                break;
              }
              console.warn('VAULT: no peer found, cannot send vault access rental');
              if (mycallback) {
                mycallback(null);
              }
              return _context0.a(2, null);
            case 5:
              this.app.network.sendRequestAsTransaction('vault access rental', payload, function (res) {
                console.log('[VAULT RENTAL ACCESS] response', res);
                if (!res) {
                  if (mycallback) {
                    mycallback(null);
                  }
                  return;
                }
                if (res.status === 'err') {
                  console.error('VAULT: rental access error', res);
                  if (mycallback) {
                    mycallback(null);
                  }
                  return;
                }
                var txs = [];
                if (res.txs) {
                  txs = res.txs;
                } else if (Array.isArray(res)) {
                  txs = res;
                }
                if (txs.length > 0) {
                  for (var i = 0; i < txs.length; i++) {
                    var tx = new Transaction();
                    tx.deserialize_from_web(_this3.app, txs[i]);
                    var _txmsg = tx.returnMessage();
                    try {
                      var filename = _txmsg.data.name;
                      if (!filename) {
                        filename = prompt('Enter filename to save:') || 'vault.bin';
                      }
                      var parts = _txmsg.data.file.split(',');
                      var header = parts[0];
                      var base64Data = parts[1];
                      var mime = header.match(/data:(.*);base64/)[1];
                      if (mycallback) {
                        mycallback(base64Data);
                      } else {
                        var binary = atob(base64Data);
                        var len = binary.length;
                        var bytes = new Uint8Array(len);
                        for (var j = 0; j < len; j++) {
                          bytes[j] = binary.charCodeAt(j);
                        }
                        var blob = new Blob([bytes], {
                          type: mime
                        });
                        var url = URL.createObjectURL(blob);
                        var a = document.createElement('a');
                        a.href = url;
                        a.download = filename || 'download';
                        a.click();
                        URL.revokeObjectURL(url);
                      }
                    } catch (err) {
                      console.log('VAULT: ERROR while handling rental downloaded file:', (err === null || err === void 0 ? void 0 : err.message) || err);
                    }
                  }
                } else if (mycallback) {
                  mycallback(null);
                }
              }, this.peer.publicKey, true);
              siteMessage('Transferring File...', 3000);
              return _context0.a(2, null);
          }
        }, _callee0, this);
      }));
      function sendAccessRentalFileRequest() {
        return _sendAccessRentalFileRequest.apply(this, arguments);
      }
      return sendAccessRentalFileRequest;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var vault_self = this;
      expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(req, res) {
          var reqBaseURL, updatedSocial, html;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                updatedSocial = Object.assign({}, vault_self.social);
                html = VaultHome(app, vault_self, app.build_number, updatedSocial);
                if (res.finished) {
                  _context1.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context1.a(2, res.send(html));
              case 1:
                return _context1.a(2);
            }
          }, _callee1);
        }));
        return function (_x1, _x10) {
          return _ref3.apply(this, arguments);
        };
      }());
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }
  }]);
}(ModTemplate);
module.exports = Vault;